export const diffDays = ({first_date, second_date}) => {
  const dateTo = new Date(first_date);
  const dateFrom = new Date(second_date);
  const diffMiliseconds = dateTo - dateFrom;
  const milisecondsToDays = 1000 * 60 * 60 * 24;
  const diffDays = Math.round(diffMiliseconds / milisecondsToDays + 1);
  return diffDays;
};
